
import styles from "./scss/neweventpopup.module.scss";
import { Dropdown, Select, Form, DatePicker, Menu } from 'antd';
import { Radio } from 'antd';
import React, { useEffect, useState } from 'react';
import IcloudImg from "../../../styles/images/event/icloud.svg";
import GoogleCalcImg from "../../../styles/images/event/google_calendar.svg";
import OutlookImg from "../../../styles/images/event/outlook.svg";
import { URButton } from "../../../shared/widgets/button";
import { useSelector } from "react-redux";
import { chats, chatwindowDetails, initialStateModel } from "../../../models/model";
import styles1 from "../../../shared/widgets/logininput/input.module.scss";
import moment from "moment";
import TextArea from "antd/lib/input/TextArea";
import { chatSideWindow, saveEventCreation } from "../../../base/eventService/eventApiService";
import { URCheckBox } from "../../../shared/widgets/checkbox";
import { useForm } from "react-hook-form";
import taskimg2 from "../../../styles/images/task2.svg";
import { SearchFilter } from "../../../base/utils";
import _ from "lodash";
import { URAvatarGroup } from "../../../shared/widgets/avatarGroup";
import { URStatusDot } from "../../../shared/widgets/avatarGroup/statusDot";
import { userStatusColor } from "../../../base/callService/common";
import { ChatService } from "../../../base/chatService";
type eventState={
  isRecurringEvent:boolean;
  recurrence:string;
  eventName:string;
  startDate:Date;
  time:any;
  hours:number;
  minutes:number;
  participants:any;
  calendarType:string;
  description:string;
  allDay: boolean;
  contacts: Array<any>;
  tempfilteredContacts: Array<any>;
  assigneeError:boolean;
  dateError:boolean;
  rruleText: string;
  startTimeError:boolean;
  nameError:boolean;
}
export default function NewEventRightCreate(props:any) {
  const {  handleSubmit, formState: { errors } } = useForm();
  //const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  const allReducer: initialStateModel = useSelector((state: initialStateModel) => state);
  const contactList = allReducer.contactReducer.workContacts;
  //let loginUser: UserDetails = store.getState().loginReducer.userdetails || [];
  const chatWindow: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  const chat_reducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  let {chatWindowDetails }=chatWindow;
  const { Option } = Select;
  let timeRes = moment(new Date()).format('HH:mm')
  var evens = _.map(contactList, function(n) {
    return n;
  });

  const [eventInfo, setEventInfo] = useState < eventState >
  ({isRecurringEvent:false,recurrence:"",eventName:"",startDate:new Date(),time:timeRes,hours:1,minutes:0,
    participants:[],calendarType:'none',description:"",allDay:false,contacts: evens,assigneeError:false,dateError:false,
    tempfilteredContacts: evens,rruleText:"",startTimeError:false,nameError:false});

 // let {eventName, startDate,participants,calendarType, description, allDay } = eventInfo;
  useEffect(() => {
    var evens = _.map(contactList, function(n) {
      return n;
    });
    setEventInfo({ ...eventInfo, tempfilteredContacts: evens,contacts:evens});
  }, [chatWindowDetails]);

  const disabledDate = (from: any, current: any)=>{
    return new Date(from.setDate(from.getDate() -1)) >= current;
  };

  const nameInputChange = (name: string,e: any) => {
    setEventInfo({ ...eventInfo,nameError:false, [name]: e.target.value});
  };

  const handleDateChange = (value:any)=>{
    setEventInfo({ ...eventInfo, startDate: value,dateError:value === null?true:false});
  };
  const handleTimeChange = (value:any)=>{
    setEventInfo({ ...eventInfo, time: value.key});
  };
  
  const onSubmit = async() => {
    let formData:any = eventInfo;
    const date = new Date();
    const currentTime = moment().format('HH:mm');
   if(eventInfo.eventName.trim() === "" ){
    setEventInfo({ ...eventInfo, nameError: true});
   } else
    if(eventInfo.participants.length <1){
      setEventInfo({ ...eventInfo, assigneeError: true});
      
    } else if(Date.parse(moment(new Date(eventInfo.startDate)).format('MM/DD/YYYY'))
    ===Date.parse(moment(date).format('MM/DD/YYYY')) && (currentTime  >  eventInfo.time)){
      setEventInfo({ ...eventInfo, startTimeError: true});
 
    }
     else {
      saveEventCreation(formData,props.module);
      if(props.module === 'contact'){
        props.handleToggle();
      } else if(props.module!=="loginuser"){
        chatSideWindow(true,"eventlist",{});
      } else if (chatWindow.isMySpace) {
        chat_reducer.isWindowSlide && ChatService.rightSideToogle();
      }

    
  }
  };
  
  const handleChange= (value:any)=>{
    let error = value.length <1 ? true:false;
    setEventInfo({ ...eventInfo, assigneeError: error, participants: value, contacts:evens});
  };

  const selectHoursDropdown= (value:any)=>{
    setEventInfo({ ...eventInfo, hours: value.key});
  };
  const selectMinsDropdown= (value:any)=>{
    setEventInfo({ ...eventInfo, minutes: value.key});
  };
  const radioChecked= (e:any)=>{
    setEventInfo({ ...eventInfo, calendarType: e.target.value});
  };

  const cancelWindow= ()=>{
    !chatWindow.isMySpace ? chatSideWindow(true,"eventlist",{}) : chat_reducer.isWindowSlide && ChatService.rightSideToogle();
    if(props.module === 'contact' && !chatWindow.isMySpace){
      props.handleToggle();
    }
  };
  const handleAlldayCheck = (e:any)=>{
    setEventInfo({...eventInfo,allDay:e.target.checked});
  };
  const searchInput = (e:string) =>{
    let searchText = e.toLowerCase();
    let filterParticipant = SearchFilter(eventInfo.tempfilteredContacts, searchText);
    // const filterParticipant:Array<any> = eventInfo.tempfilteredContacts
    //   .filter((value:any) => value.caller_id.toLowerCase().includes(searchText));
    setEventInfo({...eventInfo, contacts:filterParticipant});
  };
  let len = Math.ceil((eventInfo?.contacts?.length / 8));
  let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();
  const allcontact = Array.isArray(eventInfo?.contacts) && eventInfo?.contacts.map((contact: any,index:number) => <Option value={contact.sip_login_id}
    key={index}>
    <div className="dropdowndesign">
                      <div className="usergroupss">
                        <URAvatarGroup className={`lefts size20 colorBG${random_color[index]}`} profileInfo={<>
                          {contact.ImageURL ?
                            <img src={contact.ImageURL} alt="" className={styles.imgSelected}/> :
                            <span>{contact.caller_id?.charAt(0).toUpperCase()}</span>}
                          <URStatusDot
                            className={userStatusColor(contact?.user_status,'small')}/>
                        </> } />
                      </div>
                      <div className="names">{contact?.caller_id}</div>
                      <div className="ext">{contact?.ext}</div>
                    </div>
  </Option>);
 
  let allday:any = Array.from(Array(24).keys());
  const hours = (
    <Menu className="scroller eventHours" onClick={selectHoursDropdown}>
      {allday.map((list: any) => <Menu.Item key={list}>{list} hr</Menu.Item>)}
    </Menu>
  );
  const minuts = (
    <Menu className="scroller  eventMinutes" onClick={selectMinsDropdown}>
      <Menu.Item key={15}>15 min</Menu.Item>
      <Menu.Item key={30}>30 min</Menu.Item>
      <Menu.Item key={45}>45 min</Menu.Item>
      <Menu.Item key={0}>00 min</Menu.Item>
    </Menu>
  );
  let timeDurationList: any = Array.from(Array(24).keys());  
  const startTime = (
    <Menu className={`${"scroller"} ${styles.timeSelect}`} onClick={handleTimeChange}>
       { timeDurationList.map((value: string, index: number) => {
    return (
      <>{index === 0 ?
        <>
         <Menu.Item
            key={`${index}:00`}>{`00:00`}</Menu.Item>
          <Menu.Item 
            key={`${index}:30`}>{`00:30`}</Menu.Item>
        </>
        :
        <>
          <Menu.Item 
           key={`${value.toString().length === 1 ? '0'+value : value}:00`}>{`${value.toString().length === 1 ? '0'+value : value}:00`}</Menu.Item>
          <Menu.Item key={`${value.toString().length === 1 ? '0'+value : value}:30`}
            >{`${value.toString().length === 1 ? '0'+value : value}:30`}</Menu.Item>
           
        </>
      } 
      </>
      );
    })
  }
    </Menu>
  );

  return (
    <>
    <div className={styles.rightsidebar}>
      <div className={styles.toplayers}>
        <h3>New Event</h3>
        <span className="icon_close" onClick={cancelWindow}></span>
      </div>
      <div className={styles.middlelayers}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={`${styles.neweventpopupscreen} ${"scrollerhover"}`}>


          <div className={styles.half}>
            <div className={styles.selectopt}>
              <div className={styles.meetingRecordTitle}>Event Name</div>
              <div className={styles1.inputBox}>
                <input className={`${styles.inputarea} ${eventInfo?.nameError ? "errorInput":""}`} placeholder="Event Title" onChange={(e: any) => nameInputChange('eventName', e)} value={eventInfo.eventName}
                ></input>
              </div>
              {eventInfo?.nameError &&  <p className={styles.errorMsgs}>This event needs a name </p>}
            </div>
            {/* <div className={`${styles.alldaySec} ${styles.selectopt}`}>
              <URCheckBox  onChange={handleAlldayCheck}/> <span className={styles.allDaytxt}>All Day</span>
            </div> */}
            
            <div className={styles.selectopt}>
              <div className={styles.timedate}>
                <div className={`timefield ${styles.datesection}`}>
                <div className={styles.meetingRecordTitle} >Event Start</div>
                  <DatePicker className="customDatepicker" format={'DD/MM/YYYY'}
                    disabledDate={(e) => disabledDate(new Date(), e)}
                    defaultValue={moment(eventInfo.startDate)}
                    dropdownClassName='datepickerDropdown' placeholder='Start date' onChange={handleDateChange}/>
                </div>
              </div>
              {eventInfo.dateError && <p className={styles.errorMsgs}>Select a start date </p>}
            </div>
            
            <div className={styles.selectopt}>
              <div className={`timefield ${styles.datesection}`}>
                <div className={styles.meetingRecordTitle}>Time</div>
                {/* <TimePicker defaultValue={moment(eventInfo.time, 'h:mm a')} format={'h:mm a'}
                  onChange={handleTimeChange}/> */}
                <div className="durationes">
                  <Dropdown overlay={startTime} placement="bottomRight" className={eventInfo.startTimeError?"errorInput":''}>
                    <h3 className={styles.rightalign}>{eventInfo.time}
                    <span className={`${"icon_down-arrow"} ${"menudroprotate"}`}></span></h3></Dropdown>
                </div>
               </div>
              
              <div className={`timefield ${styles.dropdownsec}`}>
                <div className={styles.meetingRecordTitle}>Duration</div>
                <div className="durationes">
                  <Dropdown overlay={hours} placement="bottomCenter">
                    <h3 className={styles.rightalign}>{eventInfo.hours} hr
                      <span className={`${"icon_down-arrow"} ${"menudroprotate"}`}></span></h3></Dropdown>
                  <Dropdown overlay={minuts} placement="bottomCenter"><h3>{eventInfo.minutes} min
                    <span className={`${"icon_down-arrow"} ${"menudroprotate"}`}></span></h3></Dropdown>
                </div>
              </div>
            </div>
          
            <div className={styles.selectopt}>
              <div className={styles.formGrouprow}>
                <div className={styles.meetingRecordTitle}>Add Participants</div>
                <div className={styles.shareSelect}>
                  <div className={`${styles1.inputBox} ${errors.participants?'error':''}`}>
                  <div className={styles.insideicon}>
                     <img src={taskimg2} alt="" />
                    <Select
                      mode="multiple"
                      style={{ width: '100%' }}
                      placeholder="No Participants"
                      onChange={handleChange}
                      filterOption={false}
                      showSearch={true}
                      onSearch={(e: string) => searchInput(e)}
                      className={`newselects taskcreations ${eventInfo?.assigneeError ? "errorInput":""}`}
                       value={eventInfo.participants}>
                      {allcontact}
                    </Select>
                  </div>
                  </div>
                  {eventInfo?.assigneeError&& <p className={styles.errorMsgs}>Invite someone</p>}
                </div>
                </div>
            </div>
           
            
            <div className={styles.selectopt}>
            <div className={styles.meetingRecordTitle}>Add to calendar</div>
              <div className="radiobuttonsec">
                <Form.Item>
                  <Radio.Group onChange={(e)=>radioChecked(e)} value={eventInfo.calendarType}>
                  <Radio value={'none'}><span className="radiotxt">
                    None</span></Radio>
                    <Radio value={'icloud'}><span className="radiotxt"><img src={IcloudImg} alt={IcloudImg} />
                    iCloud</span></Radio>
                    <Radio value={'google'}><span className="radiotxt"><img src={GoogleCalcImg} alt={GoogleCalcImg} />
                      Google Calendar</span></Radio>
                    <Radio value={'outlook'}><span className="radiotxt"><img src={OutlookImg} alt={OutlookImg} />
                      Outlook</span></Radio>
                  </Radio.Group>
                </Form.Item>

              </div>
            </div>
            <div className={styles.selectopt}>
              <div className={styles.meetingRecordTitle}>Description</div>
              <div className={styles.editorTextarea}>
                <TextArea rows={4} onChange={(e: any) => nameInputChange('description', e)}
                  name="description" placeholder="Write a event description" className="notesArea"/>
              </div>
            </div>
            <div className={styles.bottomlayers}>
              <URButton name="Cancel" className="urButton buttonWhite" onClick={cancelWindow}/>
              <URButton name="Create" className="urButton buttonBlue marlftmin" htmlType="submit"/>
            </div>

          </div>
        </div>
      </form>
      </div>
    </div>
    </>
  );
};
